export default "__VITE_ASSET__BEgUVw07__"